import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";

function getType(target) {
  return Object.prototype.toString.call(target).slice(8, -1);
}

function isArray(target) {
  return getType(target) === 'Array';
}

function isFunction(target) {
  return getType(target) === 'Function';
}

function isObject(target) {
  return getType(target) === 'Object';
}

function isString(target) {
  return getType(target) === 'String';
}

function isNumber(target) {
  return getType(target) === 'Number';
}

function isInt(target) {
  return isNumber(target) && target.toString().indexOf('.') < 0;
}

function isFloat(target) {
  return isNumber(target) && target.toString().indexOf('.') > -1;
}

function isNull(target) {
  return getType(target) === 'Null';
}

function isDate(target) {
  return getType(target) === 'Date';
}

export { getType, isNumber, isInt, isFloat, isArray, isFunction, isNull, isObject, isString, isDate };